import * as types from '../constants/actionTypes'

export const receiveShopifyAuth = auth => ({ type: types.RECEIVE_SHOPIFY_AUTH, auth })



// WEBPACK FOOTER //
// ./src/actions/shopifyAuthDataAC.js